import React from 'react';
import PropTypes from 'prop-types';

import ImageUploader from '@hydra/routes/pdf-editor/components/ImageUploader';
import EditorFormRow from '@hydra/routes/pdf-editor/components/EditorFormRow/EditorFormRow';
import Editor from '@hydra/routes/pdf-editor/components/EditorFormRow/Editor';
import EditorInline from '@hydra/routes/pdf-editor/components/EditorFormRow/EditorInline';
import ImagePreview from '@hydra/routes/pdf-editor/components/ImagePreview';
import RichEditor from '@hydra/routes/pdf-editor/components/RichEditor/RichEditor';
import RichEditorPreview from '@hydra/routes/pdf-editor/components/RichEditor/RichEditorPreview';
import FormToggle from '@hydra/routes/pdf-editor/components/FormToggle';
import InfoLabel from '@hydra/routes/pdf-editor/components/InfoLabel';
import HelpText from '@hydra/routes/pdf-editor/components/HelpText';
import Header from '@hydra/routes/pdf-editor/components/Header';

import { Icon, Translate } from '@hydra/common/components';

import { Container } from '@material-ui/core';

export const TabConclusion = ({
  template,
  editing,
  editingValue,
  setEditingValue,
  setEditingField,
  resetEditing,
  saveFormField,
  savePdfFile,
  headerLocked,
  featuresLocked
}) => (
  <>
    <Header title='pdf_editor_review_tab_conclusion' hasLockedButton={headerLocked} />
    <Container>
      <EditorFormRow
        label={<Translate content='pdf_editor_add_conclusion' />}
        locked={featuresLocked}
      >
        <EditorInline
          Component={FormToggle}
          field='closingPage.enabled'
          value={template.closingPage.enabled}
          otherFieldOpen={(editing !== null && editing !== 'closingPage.enabled')}
          locked={featuresLocked}
          saveFormField={({ value }) => saveFormField({
            field: 'closingPage',
            value: {
              ...template.closingPage,
              enabled: value
            }
          })}
        />
      </EditorFormRow>
      {
        template.closingPage.enabled || headerLocked
          ? (
            <>
              <EditorFormRow
                label={<Translate content='pdf_editor_conclusion_text' />}
                help={<HelpText content='pdf_editor_option_help_conclusion_text' />}
                locked={featuresLocked}
              >
                <Editor
                  Component={RichEditor}
                  field='closingPage.customText'
                  preview={
                    <RichEditorPreview
                      content={template.closingPage.customText}
                      defaultContent={
                        <Translate
                          content={featuresLocked ? 'pdf_default_branded_conclusion' : 'pdf_editor_option_default_content_empty_text'}
                        />
                      }
                    />
                  }
                  value={template.closingPage.customText}
                  editingValue={editingValue}
                  editing={editing === 'closingPage.customText'}
                  otherFieldOpen={(editing !== null && editing !== 'closingPage.customText')}
                  setEditingValue={setEditingValue}
                  setEditingField={setEditingField}
                  resetEditing={resetEditing}
                  locked={featuresLocked}
                  saveFormField={({ value }) => saveFormField({
                    field: 'closingPage',
                    value: {
                      ...template.closingPage,
                      customText: value
                    }
                  })}
                />
              </EditorFormRow>
              <EditorFormRow
                label={<Translate content='pdf_editor_signature' />}
                help={<HelpText content='pdf_editor_option_help_signature' />}
                locked={featuresLocked}
              >
                <Editor
                  Component={ImageUploader}
                  disabled={!template.closingPage.enabled}
                  field='signature'
                  fileUpload
                  preview={<ImagePreview field='signature' image={template.signature} />}
                  value={template.signature}
                  editingValue={editingValue}
                  editing={editing === 'signature'}
                  otherFieldOpen={(editing !== null && editing !== 'signature')}
                  setEditingValue={setEditingValue}
                  setEditingField={setEditingField}
                  resetEditing={resetEditing}
                  savePdfFile={savePdfFile}
                  locked={featuresLocked}
                />
              </EditorFormRow>
            </>
            )
          : (
            <EditorFormRow infoLabel>
              <InfoLabel style='default'>
                <Icon type='information' style={{ marginRight: 8 }} />
                <Translate content='pdf_editor_closing_page_info' />
              </InfoLabel>
            </EditorFormRow>
            )
      }
    </Container>
  </>
);

TabConclusion.propTypes = {
  template: PropTypes.shape({
    name: PropTypes.string
  })
};

export default React.memo(TabConclusion);
